'use client'

import styled from 'styled-components'

import theme, {media} from '@/src/config/theme'

import Button from '@/src/shared/ui/button'
import {FormInput} from '@/src/shared/ui/inputs/input'
import Modal from '@/src/shared/ui/modal'

export const Wrapper = styled.footer`
  position: relative;

  width: 100%;
  display: flex;
  justify-content: center;
  background: ${theme.colors.bgDark};

  padding: 35px ${theme.token.layout.pagePaddingX};

  // 80 это отступ от мобильного боттом бара
  padding-bottom: calc(80px + 35px);

  @media ${media.md} {
    padding-bottom: 35px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: 30px;
  width: 100%;
  max-width: ${theme.sizes.container}px;

  @media ${media.md} {
    flex-direction: row;
    gap: 10px;
  }

  & > * {
    flex: 1;
    @media ${media.md} {
      gap: 15px;
    }
  }
`

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media ${media.md} {
    flex-direction: row;
  }
`

export const Left = styled(ColumnWrapper)``

export const Right = styled(ColumnWrapper)`
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  @media ${media.md} {
    gap: 10px;
  }

  @media ${media.lg} {
    flex-direction: row;
    gap: 55px;
  }
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const Link = styled.a`
  &,
  span {
    color: ${theme.colors.gray6};
  }

  &:hover {
    &,
    span {
      color: ${theme.colors.gray6};
    }
  }
`

export const NavColumn = styled(Column)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;

  @media ${media.md} {
    flex: 1;
    flex-direction: column;

    & ${Link} span {
      white-space: normal;
      word-break: break-word;
    }
  }
`

export const InfoColumn = styled(Column)<{$social?: boolean}>`
  order: ${props => (props.$social && '1') || '2'};
  justify-content: space-between;
`

export const ContactPhone = styled.a`
  color: ${theme.colors.gray6};
  white-space: nowrap;

  text-decoration: none;
  font-size: 1.35rem;
  font-weight: 450;

  &:hover {
    color: ${theme.colors.textDark};
  }

  @media ${media.md} {
    font-size: 1.875rem;
  }
`

export const Social = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  & img {
    width: 20px;
    height: 20px;
  }
`

export const InfoContainer = styled(Column)`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;

  & ${ContactPhone} {
    font-size: 1.43rem;
  }

  @media ${media.md} {
    font-size: 1.35rem;
  }
`

export const SubscribeColumn = styled(Column)`
  flex: 1;
  padding: 10px;
  border-radius: 5px;

  background: ${theme.colors.dark6};

  @media ${media.md} {
    padding: unset;
    background: unset;
  }
`

export const ColumnTitle = styled.div`
  font-weight: 450;
  color: ${theme.colors.textDark};

  width: 100%;

  @media ${media.md} {
    width: unset;
  }
`

export const SubscribeWrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const SubscribeDescription = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 15px;

  p {
    color: ${theme.colors.textDark};
  }

  p:first-child {
    color: ${theme.colors.primary};
  }

  [data-dark='true'] & {
    color: ${theme.colors.textGray};
  }
`

export const SubscriptionForm = styled.div`
  [data-dark='true'] & input {
    background: ${theme.colors.dark6};

    @media ${media.md} {
      background: inherit;
    }

    &[placeholder] {
      &::placeholder {
        color: inherit;
        opacity: 1;
      }

      &::-ms-input-placeholder {
        color: inherit;
      }
    }
  }
`

export const SubscriptionButton = styled(Button)`
  margin-top: 15px;

  padding: 14px;

  font-size: 1.125rem;
  font-weight: 450;
`

export const UserAgreeLink = styled.a`
  a& {
    text-decoration: underline;
    text-underline-offset: 4px;
  }

  color: ${theme.colors.textDark};
`
export const Copyright = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  color: ${theme.colors.textGray};
`

export const SubscriptionInput = styled(FormInput)`
  color: ${theme.colors.white};
`

export const FeedbackForm = styled.form<{$submitted?: boolean}>`
  display: flex;
  flex-direction: column;
  gap: ${props => (props.$submitted && '0') || '16px'};
`

export const FeedbackModal = styled(Modal)`
  & .ant-modal-title {
    font-size: 2rem;
  }
`
